import { render, staticRenderFns } from "./car-results.vue?vue&type=template&id=5f0a0f51"
import script from "./car-results.vue?vue&type=script&lang=js"
export * from "./car-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/forge/ab.farescraper.com/components/AppHeader.vue').default,HomeHero: require('/home/forge/ab.farescraper.com/components/HomeHero.vue').default,CarsFilters: require('/home/forge/ab.farescraper.com/components/CarsFilters.vue').default,CarsList: require('/home/forge/ab.farescraper.com/components/CarsList.vue').default,GoogleAdSense: require('/home/forge/ab.farescraper.com/components/GoogleAdSense.vue').default,ModalCompare: require('/home/forge/ab.farescraper.com/components/ModalCompare.vue').default,AppFooter: require('/home/forge/ab.farescraper.com/components/AppFooter.vue').default,AppMobileFooter: require('/home/forge/ab.farescraper.com/components/AppMobileFooter.vue').default,DebugBar: require('/home/forge/ab.farescraper.com/components/DebugBar.vue').default})
